module.exports = __webpack_public_path__ + "static/media/imtiaz-480x360@2x.e08e888f.png";